export const routes = {
  DEFAULT: "/automation",
  CREATE: "/automation/create",
  DETAIL: "/automation/details",
};

export const Trigger = "trigger";
export const inactivateModalText = `All actions and conditions within the workflow will be halted for the enrolled contacts until you reactivate it.`;
export const saveWorkflowSuccess = `Your workflow has been saved successfully!`;
export const publishWorkflowSuccess = `Your workflow has been published successfully!`;

export const CONTROLS_NAMES = {
  "send email": "Email",
  "add to list": "Add to list",
  delay: "Delay",
  end: "Stop",
  "If / Else": "Condition",
};

export const EVENT_IDS = {
  EMAIL_OPEN: 7,
  EMAIL_CLICK: 8,
  EMAIL_RECEIVED: 9,
  SHARE_PROFILE: 10,
  EMAIL_SEQUENCE: 11,
};
